import { CATEGORY_COLORS } from './categoryColors';
import { CATEGORY_PALETTE } from '../events/eventCategories';

/**
 * Admin place taxonomy (Location Manager / Location Database).
 * Colors prefer map pin colors where labels align; otherwise palette.
 */
export const PLACE_CATEGORY_DEFINITIONS = [
  { label: 'Food', color: CATEGORY_COLORS.Food },
  { label: 'Coffee', color: CATEGORY_COLORS.Coffee },
  { label: 'Drinks', color: CATEGORY_COLORS.Bars },
  { label: 'Culture', color: CATEGORY_PALETTE[0] },
  { label: 'Nature', color: CATEGORY_COLORS.Nature },
  { label: 'Shopping', color: CATEGORY_PALETTE[1] },
  { label: 'Entertainment', color: CATEGORY_COLORS.Party },
  { label: 'Sports', color: CATEGORY_COLORS.Activity },
  { label: 'Nightlife', color: CATEGORY_PALETTE[5] },
  { label: 'Historical', color: CATEGORY_COLORS.History },
];

export const PLACE_CATEGORIES = PLACE_CATEGORY_DEFINITIONS.map(({ label }) => label);

/**
 * Public display label for a place category (render-only; does not change stored values).
 * Food / Coffee / Drinks|Bar|Bars → Best ….
 * @param {string} [raw]
 * @returns {string}
 */
export function formatPlaceCategoryLabel(raw) {
  const key = String(raw || '').trim().toLowerCase();
  if (key === 'food') return 'Best Food';
  if (key === 'coffee') return 'Best Coffee';
  if (key === 'drinks' || key === 'bar' || key === 'bars') return 'Best Bar';
  return String(raw || '').trim();
}

/**
 * Labels used for category counts on a location (main + additional).
 * @param {{ mainCategory?: string, categories?: string[] }} location
 * @returns {string[]}
 */
export function getLocationCategoryLabels(location) {
  const labels = [];
  if (location?.mainCategory && typeof location.mainCategory === 'string') {
    const main = location.mainCategory.trim();
    if (main) labels.push(main);
  }
  if (Array.isArray(location?.categories)) {
    location.categories.forEach((cat) => {
      if (typeof cat === 'string' && cat.trim()) labels.push(cat.trim());
    });
  }
  return labels;
}
